import React from 'react';
import Cursor from './components/Cursor';
import ProgressBar from './components/ProgressBar';
import Nav from './components/Nav';
import Hero from './components/Hero';
import StoryReveal from './components/StoryReveal';
import PropertyMoment from './components/PropertyMoment';
import Details from './components/Details';
import Location from './components/Location';
import Opportunity from './components/Opportunity';
import Price from './components/Price';
import Handshake from './components/Handshake';
import Contact from './components/Contact';
import StickyDock from './components/StickyDock';
import { TOKENS } from './tokens';

const Divider = () => (
  <div style={{
    height: 1,
    background: 'linear-gradient(90deg, transparent, rgba(200,169,106,0.12), transparent)',
  }} />
);

function Footer() {
  return (
    <footer style={{
      background: '#050A1A',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: 'clamp(28px,4vw,44px) clamp(20px,4vw,48px)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 20,
    }}>
      <span style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '0.9rem',
        color: 'rgba(255,255,255,0.28)',
      }}>
        Jhandewalan Commercial · Delhi
      </span>
      <span style={{
        fontSize: '0.6rem',
        color: 'rgba(255,255,255,0.16)',
        maxWidth: 520,
        lineHeight: 1.7,
        textAlign: 'center',
      }}>
        225 Sq. Yard Commercial Ground Floor · Jhandewalan, New Delhi — 110055.
        All information is indicative. Buyers are advised to conduct independent due
        diligence before any transaction.
      </span>
      <span style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '0.85rem',
        color: TOKENS.GOLD,
        opacity: 0.55,
      }}>
        ₹5.55 Cr · Negotiable
      </span>
    </footer>
  );
}

export default function App() {
  return (
    <>
      <Cursor />
      <ProgressBar />
      <Nav />

      <main>
        <Hero />
        <Divider />
        <StoryReveal />
        <Divider />
        <PropertyMoment />
        <Divider />
        <Details />
        <Divider />
        <Location />
        <Divider />
        <Opportunity />
        <Divider />
        <Price />
        <Divider />
        <Handshake />
        <Divider />
        <Contact />
      </main>

      <Footer />
      <StickyDock />
    </>
  );
}
